const userRoles = {
  user: 'user',
  admin: 'admin',
  // The stored value is 'wuser' (wibki user). This read 'wpUser', which
  // matches nothing in the users.role enum - harmless only because nothing
  // consumed it until the admin role selector did.
  wpUser: 'wuser',
  // Access to the logo review queue and nothing else in /admin.
  logoReviewer: 'logo_reviewer',
};

export default userRoles;
